import React, { Component } from 'react';
import { ssCommonUtils, ssImageViewUtils, ssDateUtils } from '@bit/ui-common.ui-components/ss-utils';
import { Row, Col, Slider, Button, Icon } from 'antd';

const documentResource = {
    program: "afsp",
    resource: "applicant/document",
    contentType: "application/json",
    rotate: "rotate"
}

const userDocumentResource = {
    program: "user",
    resource: "document"
}


export default class ImageViewer extends Component{ 

    
    constructor( props ) {
        super( props );
        this.state = {
            zoom: .9,
            rotate: 0
        };
    }
 
    //TODO externalize remove that hard coded analyst
    getImageUrl( id, isThumbNail ) {
        if ( !isThumbNail ) {
            if(this.props.userType){
              return ssCommonUtils.setEnvPrefix( "/user/document/" + id + "?t=" + ssDateUtils.getCurrentUnixTime() );
            } else {
              return ssCommonUtils.setEnvPrefix( "/afsp/applicant/document/" + id + "?t=" + ssDateUtils.getCurrentUnixTime() );
            }
        } else {
          if(this.props.userType){
            return ssCommonUtils( "/user/document/" + id + "?tn=true&t=" + ssDateUtils.getCurrentUnixTime() );
          } else {
            return ssCommonUtils( "/afsp/applicant/document/" + id + "?tn=true&t=" + ssDateUtils.getCurrentUnixTime() );
          }
        }
    }

    componentDidMount() {
        this.initCanvas();
    }

    componentDidUpdate( prevProps ) {
        if ( prevProps.id !== this.props.id ) {
            this.initCanvas();
        }
    }

    fetchAndLoadImage( url, id, imgElement ) {
        const options = {
          credentials: 'include',
            headers: {
                Authorization: `Bearer ${ window.session.token }`
            }
        };

        fetch( url, options )
            .then( res => res.blob() )
            .then( blob => {
                imgElement.src = URL.createObjectURL( blob );
            } );
    }
    
    sleep (milliseconds) {
         return new Promise(resolve => setTimeout(resolve,milliseconds))
    }

    initCanvas(refresh=false) {
        const { id } = this.props;
        const {imgRotAngle} = this.props;
        if (this.state.rotate > 0 &&  refresh) { // if rotated, set back to original rotation when loaded
            const  rotReps = 4 - (this.state.rotate % 4);
            for (let i = 0; i < rotReps; i++) {
                if (i > 0) this.sleep(200); // if rotates issued too fast, can get lost or overwrite each other.
                // Yes, there should probably be a direct rotation method, rather than steps of 90, but not really high priority
                this.onRotate()
            }
        }
        else this.setState({rotate:0});

        let img1 = new Image(),
            canv = document.getElementById( 'image-canvas' ),
            imageFunctions = ssImageViewUtils.imageDrag( img1, canv, imgRotAngle );

        let ctx = canv.getContext( '2d' );

        img1.onload = function() {

            canv.style.width = 1000;
            canv.style.height = 600;
            canv.width = 1000;
            canv.height = 600;
            ctx.fillStyle = "black";
            ctx.fillRect( 0, 0, canv.width, canv.height );
            
            if (imgRotAngle > 0 ) {
                let   
                effX = canv.width / 2 -  img1.width / 2,
                effY = canv.height  /2 - img1.height / 2;
                const w = canv.width / 2, h = canv.height / 2;
                ctx.translate( w, h );       
                ctx.rotate( imgRotAngle / 180 * Math.PI );
                ctx.translate( -w, -h );
                ctx.drawImage( img1, effX, effY, img1.width, img1.height );
                ctx.restore();
            }
            else ctx.drawImage( img1, canv.width / 2 - img1.width / 2, canv.height / 2 - img1.height / 2, )     
        };

        //img1.src = ssCommonUtils.setEnvPrefix( this.getImageUrl( id, false ) );
        let url = this.getImageUrl( id, false ) ;
        this.fetchAndLoadImage( url, id, img1 );

        this.applyEventListeners( canv, imageFunctions.mouseDown, imageFunctions.handleMouseUp, imageFunctions.handleMouseOut, imageFunctions.handleMouseMove, );

        this.setState( { zoom: 1, imageFunctions: imageFunctions, canvas: canv, img1: img1} )
    }

    getRotateUrl( id ) {
        if(this.props.userType){
            return ssCommonUtils.setEnvPrefix( '/' + userDocumentResource.program + '/' + userDocumentResource.resource + '/' + id + '/' + documentResource.rotate );
        }else{
            return ssCommonUtils.setEnvPrefix( '/' + documentResource.program + '/' + documentResource.resource + '/' + id + '/' + documentResource.rotate );
        }
    }

    onRotate() {
        const { id } = this.props;
        const url = this.getRotateUrl(id) 
        
        const options = {
            credentials: 'include',
            headers: {
                Authorization: `Bearer ${ window.session.token }`
            }
        };
        this.setState( {
            ...this.state,
            loading: true,
            inError: false
        } )
        fetch( url, {
            method: 'put',
            ...options
        } )
            .then( response => response.json() )
            .then( success => {
                let ro = (this.state.rotate + 1) % 4;
                this.setState( {
                    ...this.state,
                    loading: false,
                    inError: false,
                    rotate: ro
                } );

                this
                    .state
                    .imageFunctions
                    .rotateImage( ro );
            } )
            .catch( error => this.setState( {
                ...this.state,
                loading: false,
                inError: true,
                errorMessage: error
            } ) );
    }

    applyEventListeners( canvasObj, mouseDown, handleMouseOut, handleMouseUp, handleMouseMove ) {
        canvasObj.removeEventListener( 'mousedown', mouseDown );
        canvasObj.removeEventListener( 'mouseout', handleMouseOut );
        canvasObj.removeEventListener( 'mouseup', handleMouseUp );
        canvasObj.removeEventListener( 'mousemove', handleMouseMove );

        canvasObj.addEventListener( 'mousedown', mouseDown );
        canvasObj.addEventListener( 'mouseup', handleMouseOut );
        canvasObj.addEventListener( 'mouseout', handleMouseUp );
        canvasObj.addEventListener( 'mousemove', handleMouseMove );
    }

    onZoom = ( e, scaleFunction ) => {
        if ( isNaN( e ) ) {
            return;
        }
        this.setState( { zoom: e } );
        //redraw image
        scaleFunction( e );
    }

    handleFileDownload( url ) {
        ssCommonUtils.fileDownload( url );
    }

    render() {

        const { imageFunctions, zoom, canvas, img1 } = this.state, { loading, id } = this.props;

        return ( <div style={{
                userSelect: "none"
            }}>
            <Row>
                <Col span={4}>Zoom Factor:
                </Col>
            </Row>
            <Row>
                <Col span={14}>
                    <Slider
                        min={.25}
                        max={4}
                        onChange={( e ) => this.onZoom( e, imageFunctions.scaleImage )}
                        value={this.state.zoom}
                        step={.25}/>
                </Col>
            </Row>
            <Row>
                <Col span={1}>
                    <Row>
                        <Button onClick={() => this.onRotate()} type="primary" shape="circle" icon="reload"/>
                    </Row>
                    <Row>
                        <h4>Rotate</h4>
                    </Row>
                </Col>
                <Col span={1}></Col>
                <Col span={1}>
                    <Row>
                        <Button
                            onClick={() => this.initCanvas(true)}
                            type="primary"
                            shape="circle"
                            icon="rollback"/>
                    </Row>
                    <Row>
                        <h4>Refresh</h4>
                    </Row>
                </Col>
                <Col span={21}>
                    <Row type="flex" justify="end">
                        <Button
                            onClick={() => this.props.userType?this.handleFileDownload( ssCommonUtils.setEnvPrefix( '/user/document/' + id )):
                                              this.handleFileDownload( ssCommonUtils.setEnvPrefix( '/' + documentResource.program + '/' + documentResource.resource + '/' + id ) )}
                            icon="download">Download</Button>
                    </Row>
                </Col>
            </Row>
            <Row>
                {
                    loading
                        ? <Icon type='loading' />
                        : ( <Col
                            span={24}
                            style={{
                                cursor: "grab"
                            }}>
                            <canvas id="image-canvas" ref="canvas"/>
                        </Col> )
                }
            </Row>
        </div> )

    }
}
